<script>
    import { compare } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/compare.js?1733898724699';
    import { onMount } from 'svelte';

    wyvr: {
        render: 'hydrate';
        loading: 'lazy';
    }

    export let sku;

    let contains = false;

    let compare_items;

    $: button_text = contains ? 'compare.remove_from_compare' : 'compare.add_to_compare';
    $: icon = contains ? 'remove' : 'contained';
    $: update_contain(sku);


    onMount(() => {
        compare.subscribe((compare) => {
           compare_items = compare?.items;
           update_contain();
        });
    });


    function update_contain(){
        if (!sku || typeof sku !== 'string' || !Array.isArray(compare_items)) {
            return;
        }
        const contains_sku = sku.toLowerCase();

        contains = compare_items.includes(contains_sku);
        icon = contains ? 'remove' : 'contained';
    }

    function toggle() {
        compare.toggle(sku);
    }
</script>

<button class="action-btn action-btn--compare {icon}" on:click={toggle}>
    <span class="u-tooltip text"> <slot>{window.__(button_text)}</slot></span>
</button>


<style>
    @media (min-width: 992px) {
        .action-btn::before {
            font-size: 20px;
        }
    }
</style>